{
  "app": {
    "name": "TK Vault",
    "skipToContent": "Skip to content"
  },
  "nav": {
    "main": "Main navigation",
    "dashboard": "Dashboard",
    "tickets": "Tickets",
    "search": "Search",
    "queues": "Queues",
    "noQueues": "Queues appear here after the first import.",
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "administration": "Administration",
    "users": "Users",
    "roles": "Roles and permissions",
    "audit": "Activity log",
    "imports": "Imports",
    "collapseQueue": "Collapse {{name}}",
    "expandQueue": "Expand {{name}}"
  },
  "header": {
    "searchLabel": "Search the archive",
    "searchPlaceholder": "Ticket number, subject, customer…",
    "searchPlaceholderShort": "Search…",
    "searchShortcut": "Press / to search"
  },
  "theme": {
    "label": "Appearance",
    "light": "Light",
    "dark": "Dark",
    "system": "Automatic"
  },
  "dashboard": {
    "title": "Dashboard",
    "status": {
      "title": "System status",
      "version": "Version",
      "database": "Database",
      "connected": "Connected",
      "unreachable": "Unreachable",
      "loading": "Checking…",
      "error": "The server is not responding. Make sure the backend is running.",
      "lastImport": "Last import",
      "noImport": "No import yet",
      "importOutcome": {
        "succeeded": "Completed",
        "failed": "Failed",
        "running": "Running",
        "rolled_back": "Rolled back"
      },
      "importNewTickets": "{{count, number}} new tickets",
      "importNewTickets_one": "{{count, number}} new ticket"
    },
    "favorites": "Favorites",
    "favoritesEmpty": "No favorites yet: on a ticket, press “Favorite” (or the s key).",
    "recent": "Recently viewed",
    "recentEmpty": "The tickets you open last show up here."
  },
  "archive": {
    "emptyTitle": "The archive is empty",
    "emptyBody": "Tickets appear here after the first import of the source system data. Imports start from the admin panel or the command line.",
    "title": "Archive",
    "tickets": "Tickets",
    "articles": "Articles",
    "queues": "Queues",
    "period": "Period covered",
    "periodRange": "from {{from}} to {{to}}",
    "noScopeTitle": "No queues visible",
    "noScopeBody": "Your account has no queues to browse. Ask an administrator to add at least one queue to your role (Roles and permissions → your role → Visible queues).",
    "emptyScopeTitle": "No tickets in your queues",
    "emptyScopeBody": "The queues you can browse have no tickets."
  },
  "notFound": {
    "title": "Page not found",
    "body": "This address does not match any page in the archive.",
    "back": "Back to the dashboard"
  },
  "studio": {
    "craftedBy": "crafted with",
    "name": "0Effort"
  },
  "common": {
    "close": "Close",
    "save": "Save",
    "cancel": "Cancel",
    "create": "Create",
    "edit": "Edit",
    "delete": "Delete",
    "copy": "Copy",
    "copied": "Copied",
    "yes": "Yes",
    "no": "No",
    "none": "None",
    "loading": "Loading…",
    "previous": "Previous",
    "next": "Next",
    "saved": "Changes saved",
    "errorGeneric": "Something went wrong. Try again."
  },
  "auth": {
    "loading": "Checking access…",
    "brandTagline": "Our digital diary of secrets, archived with love",
    "signInTitle": "Sign in to the archive",
    "username": "Username or email",
    "password": "Password",
    "signIn": "Sign in",
    "invalidCredentials": "Wrong username or password.",
    "locked": "Account locked after too many attempts. Try again after {{time}} or ask an administrator to unlock it.",
    "lockedNow": "Account locked after too many failed attempts.",
    "retryIn": "Try again in {{time}}",
    "lockOver": "You can try to sign in again.",
    "rateLimited": "Too many attempts from this device. Try again in a few minutes.",
    "mfaTitle": "Two-step verification",
    "mfaBody": "Enter the 6-digit code shown by your authenticator app.",
    "code": "Code",
    "verify": "Verify",
    "invalidCode": "Invalid or expired code.",
    "passwordChangeTitle": "Choose a new password",
    "passwordChangeBody": "Set a personal password to continue.",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Repeat the new password",
    "passwordsDiffer": "The passwords do not match.",
    "changePassword": "Change password",
    "passwordHint": "At least {{length}} characters, with upper and lower case letters and digits or symbols.",
    "policy": {
      "too_short": "The password is too short.",
      "too_few_classes": "Use upper and lower case letters and digits or symbols.",
      "contains_username": "The password cannot contain the username.",
      "same_as_current": "The new password must differ from the current one."
    },
    "setupTitle": "Turn on two-step verification",
    "setupBody": "Scan the QR code with an authenticator app, then enter the generated code.",
    "setupRequired": "Your role requires a second factor to access the archive.",
    "setupManual": "Can't scan the code? Enter this key in the app:",
    "activate": "Turn on",
    "signOut": "Sign out"
  },
  "user": {
    "menu": "User menu",
    "profile": "Profile"
  },
  "profile": {
    "title": "Profile",
    "account": "Account",
    "username": "Username",
    "email": "Email",
    "roles": "Roles",
    "noRoles": "No roles assigned",
    "passwordChanged": "Password updated.",
    "twoFactor": "Two-step verification",
    "twoFactorOn": "On: signing in also asks for an authenticator code.",
    "twoFactorOff": "Off. Add a second factor to protect access to the archive.",
    "enable2fa": "Turn on two-step verification",
    "disable2fa": "Turn off",
    "disable2faTitle": "Turn off two-step verification",
    "disable2faBody": "Confirm with your password and an app code.",
    "enabled2fa": "Two-step verification is on.",
    "disabled2fa": "Two-step verification is off.",
    "requiredByRole": "Your role requires two-step verification: it cannot be turned off."
  },
  "admin": {
    "users": {
      "title": "Users",
      "new": "New user",
      "user": "User",
      "email": "Email",
      "roles": "Roles",
      "status": "Status",
      "twoFactor": "2FA",
      "lastLogin": "Last sign-in",
      "active": "Active",
      "inactive": "Deactivated",
      "locked": "Locked",
      "mustChange": "Must change password",
      "never": "Never",
      "username": "Username",
      "displayName": "Display name",
      "usernameHint": "Letters, digits and . _ - @. Cannot be changed later.",
      "editTitle": "Edit user",
      "createdTitle": "User created",
      "temporaryPassword": "Temporary password",
      "temporaryPasswordBody": "Give it to the user: it is shown only now. They must choose a new one at first sign-in.",
      "resetPassword": "Reset password",
      "reset2fa": "Reset 2FA",
      "unlock": "Unlock",
      "reset2faDone": "Two-step verification reset.",
      "unlockDone": "Account unlocked.",
      "accountActive": "Account active",
      "permissionOverrides": "Permission exceptions",
      "overridesHint": "Grant or revoke single permissions on top of the roles.",
      "inherit": "As per roles",
      "grant": "Grant",
      "revoke": "Revoke",
      "personalScope": "Queues visible in addition to the roles",
      "personalScopeHint": "Optional: rules for this user only.",
      "empty": "No users.",
      "errors": {
        "username_taken": "This username already exists.",
        "email_taken": "This email is used by another user.",
        "cannot_deactivate_self": "You cannot deactivate your own account.",
        "last_admin": "At least one active administrator must remain.",
        "admin_protected": "Administrators cannot change other administrators.",
        "admin_role_reserved": "Only an administrator can give or remove the Administrators role.",
        "cannot_change_own_access": "You cannot change your own roles or permissions: ask an administrator.",
        "permission_escalation": "You cannot hand out permissions you do not hold.",
        "cannot_delete_self": "You cannot delete your own account.",
        "cannot_view_self": "You already see the panel as yourself.",
        "view_as_not_allowed": "This user sees more than you do: only an administrator can view the panel as them.",
        "user_inactive": "The account is disabled.",
        "view_as_read_only": "Changes are disabled while viewing as another user."
      },
      "delete": "Delete user",
      "deleteNow": "Delete for good",
      "deleteConfirm": "Delete {{name}} ({{username}})? The account goes with its sessions, roles and personal permissions. The activity log keeps the name. This cannot be undone.",
      "viewAs": "View as",
      "adminProtected": "This is an administrator: other administrators cannot change or delete them, reset their password or two-step verification, nor view the panel as them.",
      "adminRoleReserved": "Only an administrator can give or remove this role."
    },
    "roles": {
      "title": "Roles and permissions",
      "new": "New role",
      "list": "Roles",
      "matrix": "Compare permissions",
      "matrixHint": "To work on one role use “Edit”. Here you compare the roles you choose and, if needed, change several roles' permissions together.",
      "showRole": "Role to edit",
      "name": "Name",
      "description": "Description",
      "require2fa": "Requires two-step verification",
      "users_one": "{{count}} user",
      "users_other": "{{count}} users",
      "system": "System role",
      "editTitle": "Edit role",
      "createTitle": "New role",
      "scope": "Visible queues",
      "scopeHint": "Users of the role see the tickets that match at least one rule.",
      "systemScope": "The system role sees every queue and holds every permission.",
      "deleteConfirm": "Delete the role “{{name}}”? Users will lose the permissions it grants.",
      "saveMatrix": "Save permissions",
      "errors": {
        "name_taken": "A role with this name already exists.",
        "system_role": "The system role cannot be deleted.",
        "unknown_queue": "One of the selected queues no longer exists.",
        "system_role_locked": "The Administrators role cannot be changed.",
        "permission_escalation": "You cannot hand out permissions you do not hold."
      },
      "systemLocked": "The Administrators role is fixed: name, description, permissions and queues cannot change. You can only require two-step verification of every administrator.",
      "noQueues": "No queues",
      "noQueuesWarning": "Without at least one rule below, members of this role see no ticket. Add a rule (even “All queues”).",
      "compared": "Roles compared",
      "permissions": "Permissions",
      "permissionsHint": "What members of this role can do.",
      "systemPermissions": "The Administrators role always holds every permission."
    },
    "scope": {
      "addRule": "Add rule",
      "removeRule": "Remove rule",
      "queue": "Queue",
      "allQueues": "All queues",
      "includeSubqueues": "Include sub-queues",
      "customer": "Customer (optional)",
      "customerHint": "Customer key or address; * as wildcard, e.g. ACME*",
      "from": "From",
      "to": "To",
      "noRules": "No rules: no tickets visible.",
      "rule": "Rule {{n}}",
      "retired": "retired"
    },
    "audit": {
      "title": "Activity log",
      "when": "Date and time",
      "user": "User",
      "action": "Action",
      "target": "Object",
      "ip": "IP address",
      "details": "Details",
      "filterAction": "Activity type",
      "allActions": "All",
      "filterFrom": "From",
      "filterTo": "To",
      "empty": "No activity matches these filters.",
      "total_one": "{{count}} entry",
      "total_other": "{{count}} entries",
      "groups": {
        "auth": "Sign-ins",
        "ticket": "Ticket views",
        "admin": "Administration",
        "cli": "Command line"
      }
    }
  },
  "permissions": {
    "groups": {
      "archive": "Archive",
      "ticket": "Ticket content",
      "attachment": "Attachments",
      "export": "Export and print",
      "admin": "Administration"
    },
    "archive.browse": "Browse tickets",
    "dashboard.view": "See the dashboard",
    "search.fulltext": "Full-text search",
    "ticket.internal_notes": "See internal notes",
    "ticket.history": "See the history",
    "customer.contact": "See customer contacts",
    "attachment.view": "See attachments",
    "attachment.download": "Download attachments",
    "export.pdf": "Export to PDF",
    "export.eml": "Export emails (EML/MBOX)",
    "export.json": "Export to JSON",
    "export.csv": "Export lists to CSV",
    "export.xlsx": "Export lists to Excel",
    "export.zip": "Bulk exports (ZIP)",
    "print": "Print",
    "admin.users": "Manage users",
    "admin.roles": "Manage roles and permissions",
    "admin.import": "Import data",
    "admin.themes": "Manage themes",
    "admin.settings": "Change settings",
    "admin.audit": "Read the activity log",
    "admin.users_delete": "Delete users",
    "admin.users_view_as": "View the panel as another user"
  },
  "service": {
    "retry": "Try again",
    "autoRetry": "Retrying automatically every 10 seconds.",
    "banner": "Service problem",
    "adminHint": "For whoever runs the server",
    "database_unavailable": {
      "title": "The database is unreachable",
      "body": "The archive will be back as soon as the database is running again.",
      "hint": "check that the MariaDB service is running and reachable at the configured address (DB_HOST, DB_PORT in .env)."
    },
    "database_access_denied": {
      "title": "The server cannot sign in with the database credentials",
      "body": "The database answers but refuses the application's credentials.",
      "hint": "check DB_USER and DB_PASSWORD in .env (python -m app.cli db-init can regenerate them)."
    },
    "database_missing": {
      "title": "The archive database does not exist",
      "body": "The database server is running, but the archive database was never created.",
      "hint": "run python -m app.cli db-init, then python -m app.cli db-upgrade."
    },
    "schema_outdated": {
      "title": "The archive schema is out of date",
      "body": "The application is newer than the database structure.",
      "hint": "run python -m app.cli db-upgrade and reload the page."
    },
    "server_unreachable": {
      "title": "The archive server does not answer",
      "body": "This page cannot reach the application.",
      "hint": "check that the application is running (python -m app.cli serve) and this device is on the same network."
    }
  },
  "imports": {
    "title": "Imports",
    "workerDown": "The process that runs imports is not responding: jobs stay queued. Restart the archive service (on the server: sudo systemctl restart ticket-vault).",
    "upload": {
      "title": "Upload a dump",
      "intro": "Choose the source system backup (.sql or .sql.gz) from your computer. .sql files are compressed in the browser before sending, so far less data travels. If the connection drops, choose the same file again: the upload resumes where it stopped.",
      "file": "Dump file",
      "willCompress": "will be compressed while sending",
      "asIs": "already compressed, sent as it is",
      "resumeFound": "This file was already partly uploaded ({{percent}}): the upload resumes from there.",
      "start": "Upload",
      "resume": "Resume",
      "pause": "Pause",
      "cancel": "Cancel upload",
      "discard": "Delete",
      "progressLabel": "Upload progress",
      "progress": "{{sent}} of {{total}} ({{percent}})",
      "speed": "{{speed}}/s",
      "left": "about {{time}} left",
      "compressed": "{{stored}} transferred after compression",
      "paused": "Upload paused. Press Resume to continue, even later.",
      "done": "Upload complete: {{file}} is ready to import.",
      "unfinished": "Interrupted uploads",
      "unfinishedHint": "To resume one, choose the same file again above.",
      "choose": "Choose file",
      "noFile": "No file chosen"
    },
    "files": {
      "title": "Files ready to import",
      "intro": "Dumps uploaded above, or copied straight to the server, are listed here.",
      "serverFolder": "Server folder:",
      "free": "{{free}} free",
      "name": "File",
      "size": "Size",
      "modified": "Date",
      "actions": "Actions",
      "inUse": "in use",
      "import": "Import…",
      "delete": "Delete",
      "deleteTitle": "Delete the file?",
      "deleteBody": "{{file}} will be deleted from the server. The archive already imported does not change.",
      "empty": "No dumps on the server."
    },
    "run": {
      "title": "Import {{file}}",
      "intro": "The import runs in the background: you can close the page and follow it under Activity. Tickets already present and unchanged are skipped.",
      "dryRun": "Try without saving",
      "dryRunHint": "Reads the dump and counts what would change, without touching the archive.",
      "attachments": "Import attachment contents",
      "attachmentsHint": "Takes much more space. Without it, attachments keep name, type and size.",
      "inlineImages": "Images inside emails",
      "inlineImagesHint": "Images shown in the email text (logos, pasted screenshots).",
      "start": "Start import",
      "startDry": "Start the trial",
      "repairText": "Repair damaged texts using the original emails (recommended)",
      "repairTextHint": "In the old helpdesk some emails lost accented letters and symbols, shown as ?. The dump also holds each original email as it arrived: TK Vault uses it to rebuild the correct text, for those messages only. Turn it off only for a slightly faster import, accepting the ? in the texts."
    },
    "jobs": {
      "title": "Activity",
      "job": "Activity",
      "state": "Status",
      "outcome": "Result",
      "when": "Started",
      "took": "took {{time}}",
      "details": "Details",
      "detailTitle": "Activity #{{id}}",
      "cancel": "Cancel",
      "dryRun": "trial",
      "empty": "No activity yet.",
      "counts": "{{new}} new tickets, {{updated}} updated, {{unchanged}} unchanged",
      "rolledBack": "{{removed}} tickets removed, {{restored}} restored to their previous version",
      "interruptedHint": "The activity stopped because the service was restarted or stopped. If it was an import, the archive can be taken back with “Undo this import”.",
      "kinds": {
        "import": "Import",
        "rollback": "Undo"
      },
      "status": {
        "queued": "Queued",
        "running": "Running",
        "succeeded": "Completed",
        "failed": "Failed",
        "interrupted": "Interrupted",
        "cancelled": "Cancelled"
      }
    },
    "stages": {
      "restore": "Reading the dump",
      "lookups": "Queues, states and people",
      "tickets": "Tickets",
      "index": "Search index",
      "stats": "Statistics",
      "cleanup": "Cleanup",
      "rollback": "Undo"
    },
    "batches": {
      "title": "Imports run",
      "batch": "Import",
      "tickets": "Tickets",
      "empty": "No imports yet.",
      "rollback": "Undo this import",
      "rollbackTitle": "Undo import #{{id}}?",
      "rollbackBody": "The archive goes back to how it was: {{new}} added tickets will be removed and {{updated}} changed tickets will return to their previous version.",
      "status": {
        "running": "Running",
        "succeeded": "Completed",
        "failed": "Failed",
        "rolled_back": "Undone"
      }
    },
    "errors": {
      "unsupported_file": "Choose a .sql or .sql.gz dump.",
      "already_compressed": "The file is already compressed.",
      "empty_file": "The file is empty.",
      "insufficient_storage": "Not enough space on the server: {{needed}} needed, {{free}} left.",
      "upload_closed": "This upload was closed or cancelled. Choose the file again to start over.",
      "checksum_mismatch": "A piece of the file arrived damaged. Check the connection and press Resume.",
      "invalid_chunk": "A piece of the file is not valid. Start the upload again.",
      "network": "Connection to the server lost. The upload is stopped: press Resume when the network is back.",
      "not_found": "The file no longer exists on the server.",
      "file_in_use": "The file is used by a running activity.",
      "job_active": "Another activity is queued or running: wait for it to finish.",
      "not_cancellable": "The activity has already started and can no longer be cancelled.",
      "storage_full": "No space left on the server (disk full or the user's quota in Virtualmin reached). Free some space or raise the quota, then press Resume."
    }
  },
  "tickets": {
    "filters": {
      "text": "Number or title",
      "textPlaceholder": "e.g. 2024031510000123 or printer",
      "queue": "Queue",
      "allQueues": "All queues",
      "state": "State",
      "allStates": "All states",
      "customer": "Customer",
      "customerPlaceholder": "customer code or user",
      "from": "Created from",
      "to": "Created until",
      "sort": "Sort by",
      "apply": "Filter",
      "reset": "Reset",
      "owner": "Assigned to",
      "allOwners": "All agents"
    },
    "sorts": {
      "created_desc": "Newest",
      "created_asc": "Oldest",
      "changed_desc": "Last change",
      "number_desc": "Number"
    },
    "columns": {
      "ticket": "Ticket",
      "queue": "Queue",
      "state": "State",
      "customer": "Customer",
      "created": "Created",
      "owner": "Assigned to"
    },
    "untitled": "(no title)",
    "messages_one": "{{count}} message",
    "messages_other": "{{count}} messages",
    "emptyTitle": "No tickets match these filters",
    "emptyBody": "Widen or reset the filters to see every ticket you can browse.",
    "range": "{{from}}–{{to}} of {{total}}",
    "none": "No tickets",
    "saved": {
      "label": "Saved filters",
      "choose": "Choose a filter…",
      "none": "No saved filters",
      "save": "Save these filters",
      "delete": "Delete saved filter",
      "dialogTitle": "Save the filters",
      "dialogBody": "You will find it under “Saved filters”, from other devices too.",
      "name": "Name"
    }
  },
  "ticket": {
    "back": "Back to the list",
    "backToSearch": "Back to the search",
    "notFoundTitle": "Ticket not found",
    "notFoundBody": "Ticket {{number}} does not exist or is not in the queues you can browse.",
    "details": "Ticket details",
    "state": "State",
    "queue": "Queue",
    "priority": "Priority",
    "owner": "Owner",
    "created": "Created",
    "changed": "Last change",
    "closed": "Closed",
    "customer": "Customer",
    "attachments": "Attachments",
    "unnamedFile": "unnamed file",
    "noDownloadPermission": "You are not allowed to download attachments.",
    "contentNotImported": "The content of this attachment was not imported.",
    "sender": {
      "customer": "Customer",
      "agent": "Agent",
      "system": "System"
    },
    "internal": "Internal note",
    "collapse": "Collapse the message",
    "expand": "Expand the message",
    "to": "To",
    "cc": "Cc",
    "lostChars": "Some characters of this message were already lost in the old helpdesk (shown as ?).",
    "repaired": "Text rebuilt from the original email: in the old helpdesk it had lost characters.",
    "emptyBody": "(message without text)",
    "thread_one": "Conversation ({{count}} message)",
    "thread_other": "Conversation ({{count}} messages)",
    "collapseAll": "Collapse all",
    "expandAll": "Expand all",
    "history_one": "History ({{count}} event)",
    "history_other": "History ({{count}} events)",
    "show": "Show",
    "hide": "Hide",
    "viewAs": "Show the message as",
    "views": {
      "html": "Formatted",
      "text": "Text only"
    },
    "htmlFrame": "Formatted message",
    "htmlError": "The formatted version could not be shown: use “Text only”.",
    "remoteBlocked_one": "1 external image was not loaded (it would tell the sender the email was opened).",
    "remoteBlocked_other": "{{count}} external images were not loaded (they would tell the sender the email was opened).",
    "inlineMissing_one": "1 image of the message is not in the archive.",
    "inlineMissing_other": "{{count}} images of the message are not in the archive.",
    "previous": "Previous",
    "next": "Next",
    "favorite": "Favorite",
    "unfavorite": "Remove from favorites",
    "copyLink": "Copy link",
    "linkCopied": "Link copied"
  },
  "search": {
    "label": "Search the tickets",
    "hint": "Searches subjects, texts, addresses and numbers. \"exact phrase\", -word to exclude, prefix* for words starting like that. A ticket number opens that ticket.",
    "submit": "Search",
    "subjectOnly": "Subject only",
    "intro": "Type what you are looking for: words from the text, an email address, a customer or a ticket number.",
    "noResults": "No results for “{{q}}”",
    "noResultsBody": "Try different or less specific words, or remove the dates. Words shorter than 3 letters are not searched.",
    "results": "Search results",
    "matches_one": "{{count}} matching message",
    "matches_other": "{{count}} matching messages",
    "total_one": "{{formatted}} ticket found",
    "total_other": "{{formatted}} tickets found",
    "owner": "assigned to {{name}}"
  },
  "viewAs": {
    "banner": "You are seeing TK Vault as {{name}} ({{username}}): their permissions and queues apply, changes are disabled.",
    "stop": "Back to your account",
    "profileDisabled": "While seeing the panel as another user you cannot change the password or two-step verification."
  },
  "paging": {
    "perPage": "Per page",
    "all": "All",
    "shown": "{{loaded}} of {{total}} shown",
    "loadMore": "Load more"
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "intro": "They work when you are not typing in a field.",
    "enter": "Enter",
    "search": "Search the archive",
    "move": "List and search: next / previous row. Ticket: next / previous ticket",
    "open": "Opens the selected ticket",
    "back": "Back to the list",
    "favorite": "Adds or removes the ticket from favorites",
    "help": "Shows this help",
    "close": "Closes menus and dialogs"
  }
}
